import React from "react";
import { Link } from "react-router-dom";

const PRODUCT_LINKS = [
  { to: "/pricing", label: "Pricing" },
  { to: "/security", label: "Security" },
  { to: "/docs", label: "Docs" },
];

// Item 24: the Legal column that used to be deliberately absent — the old
// comment here said to add it "once those pages are real", and now they are.
const LEGAL_LINKS = [
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
];

function FooterColumn({ title, links }) {
  return (
    <div>
      <p className="mb-4 text-xs font-semibold uppercase tracking-widest text-rf-text-muted">
        {title}
      </p>
      <ul className="flex flex-col gap-3">
        {links.map((link) => (
          <li key={link.to}>
            <Link
              to={link.to}
              className="cursor-pointer text-sm text-rf-text-secondary transition-colors duration-200 hover:text-rf-text-primary"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function MarketingFooter() {
  return (
    <footer className="border-t border-rf-border">
      <div className="mx-auto max-w-6xl px-6 py-16 md:px-8">
        <div className="flex flex-col gap-12 md:flex-row md:justify-between">
          <div className="max-w-xs">
            <Link to="/" className="flex cursor-pointer items-center gap-2.5">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-rf-accent to-rf-accent-blue text-sm font-bold text-white">
                A
              </div>
              <span className="text-lg font-bold tracking-tight text-rf-text-primary">
                Anthurium
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-rf-text-secondary">
              Review triage for teams shipping faster than they can review.
            </p>
          </div>

          {/* Wrapped so `md:justify-between` still reads brand-left /
              links-right. Without this the two columns become separate flex
              children and the row spreads into three evenly-spaced blocks. */}
          <div className="flex gap-16">
            <FooterColumn title="Product" links={PRODUCT_LINKS} />
            <FooterColumn title="Legal" links={LEGAL_LINKS} />
          </div>
        </div>

        <p className="mt-16 text-xs text-rf-text-muted">
          © {new Date().getFullYear()} Anthurium. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
